<template>
	<div class="newsdetail">
		
		<!-- 头部 -->
		<zmlmenupage cn-name='资讯中心' en-name='News Center' class="myMenu2"></zmlmenupage>
		
		
		<div class="info newsdetailInfo" v-if="newsdetail!=''">
			<div class="newsdetail-return">
				<span class="newsReturn" @click="newsReturn">
					<i class="el-icon-arrow-left"></i>返回
				</span>
			</div>
			<div class="newsdetail-content flexBetween">
				<div class="newsdetail-left">
					<div class="newsdetail-title">
						<p>{{newsdetail.title}}</p>
						<p>{{newsdetail.createTime}}</p>
					</div>
					<div class="newsdetail-text" v-html="newsdetail.content">
						<!-- {{newsdetail.content}} -->
					</div>
					<div class="newsdetail-page flexCenter">
						<router-link to="" @click.native="prevNewspage">上一篇</router-link>
						<router-link to="" @click.native="nextNewspage">下一篇</router-link>
					</div>
				</div>
				<div class="newsdetail-right">
					<p class="newsdetail-right-title">猜你喜欢</p>
					<div class="newsdetail-list">
						<div class="newsdetail-item" v-if="preArticle!=null">
							<img :src="preArticle.url" alt=""/>
							<div class="swiper-slide-text">
								<p>{{preArticle.title}}</p>
								<p>{{preArticle.createTime}}</p>
							</div>
							<div class="swiper-slide-more flexItems flexBetween">
								<router-link to="" @click.native="_getNewsDetail(preArticle.id)">查看详情 &gt;</router-link>
								<span>01</span>
							</div>
						</div>
						<div class="newsdetail-item" v-if="nextArticle!=null">
							<img :src="nextArticle.url" alt=""/>
							<div class="swiper-slide-text">
								<p>{{nextArticle.title}}</p>
								<p>{{nextArticle.createTime}}</p>
							</div>
							<div class="swiper-slide-more flexItems flexBetween">
								<router-link to="" @click.native="_getNewsDetail(nextArticle.id)">查看详情 &gt;</router-link>
								<span v-if="preArticle==null">01</span>
								<span v-if="preArticle!=null">02</span>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<gototop></gototop>
	</div>
</template>
<script>
	import {getNewsDetail} from '@/api/api'
  export default{
	name:'newsdetail',
    data(){
      return{
		newsId:'',
		newsdetail:[],
		nextArticle:[], //下一篇
		preArticle:[]  //上一篇
      }
    },
	methods:{
		// 返回上一路由
		newsReturn(){
			this.$router.go(-1);
		},
		// 上一篇
		prevNewspage(id){
			if(this.preArticle == null){
				this.$message({
				  message: '前面没有了',
				  type: 'warning',
				  duration: 1000
				});
			}else{
				window.scrollTo(0,0);
				this._getNewsDetail(this.preArticle.id);
			}
		},
		// 下一篇
		nextNewspage(id){
			if(this.nextArticle == null){
				this.$message({
				  message: '往后没有了',
				  type: 'warning',
				  duration: 1000
				});
			}else{
				window.scrollTo(0,0);
				this._getNewsDetail(this.nextArticle.id);
			}
		},
		// 新闻详情
		_getNewsDetail(id){
			getNewsDetail(id).then((res)=>{
				console.log(res.data)
				this.newsdetail = res.data.data.article
				this.nextArticle = res.data.data.nextArticle;
				this.preArticle = res.data.data.preArticle;
			}).catch((err)=>{
				
			})
		},
	},
	mounted() {
		this.newsID = this.$route.query.id;
		this._getNewsDetail(this.$route.query.id)
	},
	created() {
		
	}
  }
</script>
<style scoped="scoped">
.newsdetailInfo{
	padding-top: 108px;
}
.newsdetail-return{
	padding: 100px 0;
}
.newsReturn{
	font-size: 16px;
	color: #999999;
	display: flex;
	align-items: center;
	cursor: pointer;
}
.newsReturn i{
	font-size: 20px;
	margin-right: 5px;
}
.newsdetail-left{
	width: 853px;
	height: auto;
}
.newsdetail-right{
	width: 419px;
	height: auto;
}
.newsdetail-right-title{
	font-size: 28px;
	font-weight: bold;
}
.newsdetail-item{
	width: 100%;
	margin-top: 40px;
	transition: .3s;
}
.newsdetail-item img{
	width: 100%;
}
.newsdetail-item:hover{
	transform: translateY(-40px);
	box-shadow: 0 5px 10px 0 rgba(0,0,0,.1);
}

.newsdetail-content{
	padding-bottom: 150px;
}
.newsdetail-title{
	border-bottom: 1px solid #EAEAEF;
	color: #999;
}
.newsdetail-title p:nth-of-type(1){
	font-size: 28px;
	color: #282828;
	margin-bottom: 40px;
}
.newsdetail-title p:nth-of-type(2){
	margin-bottom: 15px;
}
.newsdetail-text{
	padding: 20px 0;
	color: #666;
}
.newsdetail-text p,
.newsdetail-text img{
	margin: 30px 0;
	line-height: 28px;
	height: auto;
}
.newsdetail-text p{
	text-indent: 2em;
}
>>>.newsdetail-text p strong{
	/* margin: auto; */
	/* float: left; */
	display: flex;
}
>>>.newsdetail-text img{
	max-width: 100%;
	height: auto;
}
.newsdetail-page a{
	font-size: 16px;
	color: #999;
	margin: 0px 39px;
}
>>>.newsdetail-text p{
	display: flex;
	flex-wrap: wrap;
	line-height: 32px;
}
@media only screen and (max-width: 1400px) {
	.newsdetail-left{
		width: 50%;
	}
}

@media only screen and (max-width: 750px){
	.newsdetailInfo{
		padding-top: 0px;
		border-top: 10px solid #F4F4F6;
	}
	.newsdetail-return{
		display: none;
	}
	.newsdetail-left{
		width: 100%;
	}
	.newsdetail-right{
		display: none;
	}
	.newsdetail-title{
		margin: 30px 0;
	}
	.newsdetail-title p:nth-of-type(1){
		font-size: 18px;
		font-weight: bold;
		margin-bottom: 30px;
	}
	.newsdetail-title p:nth-of-type(2){
		font-size: 10px;
	}
	.newsdetail-text {
		padding: 0;
	}
	.newsdetail-text p{
		font-size: 14px;
	}
	.newsdetail-text p, .newsdetail-text img {
		width: 100%;
		margin: 10px 0;
	}
	/* .newsdetail-page{
		display: none;
	} */
	>>>.newsdetail-text img{
		width: 100% !important;
	}
	>>>.newsdetail-text p strong img{
		width: 50% !important;
	}
}
</style>



// WEBPACK FOOTER //
// src/pages/newsdetail.vue